import React, { useState } from 'react';
import '../App.css';
import TopBar from "../components/TopBar";
import ContactForm from "../components/ContactForm";
import TeamCard from "../components/TeamCard";
import Footer from "../components/Footer";
import SplashScreen from "../components/SplashScreen";
import Banner from "../components/Banner";
import healthcareImage from "../images/senior_hand_hold.jpg";
import jamesImage from "../images/james.jpg";
import { Link } from "react-router-dom";

function Home() {
  const [showSplash, setShowSplash] = useState(true);
  const [currentSlide, setCurrentSlide] = useState(0);
  const [showBanner, setShowBanner] = useState(false);
  const [shouldBounce, setShouldBounce] = useState(true);

  // Show banner after 3 seconds
  React.useEffect(() => {
    const timer = setTimeout(() => {
      setShowBanner(true);
    }, 3000);
    return () => clearTimeout(timer);
  }, []);

  // Bounce animation effect
  React.useEffect(() => {
    if (showBanner) return; // Don't bounce if banner is open

    const bounceInterval = setInterval(() => {
      setShouldBounce(true);
      setTimeout(() => {
        setShouldBounce(false);
      }, 1500); // Duration of the bounce animation
    }, 8000); // Repeat every 8 seconds

    return () => clearInterval(bounceInterval);
  }, [showBanner]);

  // Slideshow effect
  React.useEffect(() => {
    const slides = document.querySelectorAll('.slide-image');
    const interval = setInterval(() => {
      slides[currentSlide].classList.remove('active');
      const nextSlide = (currentSlide + 1) % slides.length;
      slides[nextSlide].classList.add('active');
      setCurrentSlide(nextSlide);
    }, 5000); // Change slide every 5 seconds

    return () => clearInterval(interval); // Cleanup on unmount
  }, [currentSlide]);

  return (
    <div className="App">
      {showSplash && <SplashScreen onComplete={() => setShowSplash(false)} />}
      {/* Temporary Event Banner */}
      {/* <Banner
        isOpen={showBanner}
        onClose={() => setShowBanner(false)}
        backgroundImage="/canada_day.avif"
        title="Connection Health Care - Canada Day Event Partner"
        message={`Proud Event Partner of Richmond Hill Canada Day.\n\nJoin us at Richmond Hill Canada Day on Tuesday, July 1, 2026, 2:00 PM – 8:00 PM at Richmond Green Park, 1300 Elgin Mills Road East, Richmond Hill, ON!\n\nConnection Health Care is proud to be an event partner for the Richmond Hill Canada Day celebration at Richmond Green Park.\n\nVisit our booth for lucky draws with special gifts andto learn more about our Personal Support Worker (PSW) and home care services for seniors, families, and individuals who need compassionate care at home.`}
        linkText="Visit Canada Day @ RichmondHill.ca to learn more"
        linkUrl="https://www.richmondhill.ca/en/things-to-do/canada-day.aspx#Event-Partners"
      /> */}
      {/* Info Icon to Reopen Banner */}
      {/* {!showBanner && (
        <button
          onClick={() => setShowBanner(true)}
          className={shouldBounce ? 'bounce-animation' : ''}
          style={{
            position: 'fixed',
            bottom: '30px',
            right: '30px',
            width: '50px',
            height: '50px',
            borderRadius: '50%',
            background: '#FFD700',
            border: 'none',
            cursor: 'pointer',
            fontSize: '28px',
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
            boxShadow: '0 4px 12px rgba(0, 0, 0, 0.15)',
            zIndex: 100,
            transition: 'box-shadow 0.2s ease',
          }}
          onMouseEnter={(e) => {
            e.currentTarget.style.boxShadow = '0 6px 16px rgba(0, 0, 0, 0.2)';
          }}
          onMouseLeave={(e) => {
            e.currentTarget.style.boxShadow = '0 4px 12px rgba(0, 0, 0, 0.15)';
          }}
          title="Click to view event details"
        >
          ℹ️
        </button>
      )} */}
      <TopBar />
      <div className="App-header" style={{ minHeight: '400px', backgroundImage: `url(${healthcareImage})`, backgroundSize: 'cover', backgroundPosition: 'center', width: '100%', boxSizing: 'border-box' }}>
        <div className="hero-text" style={{ position: 'relative', zIndex: 2, background: 'rgba(255,255,255,0.6)', borderRadius: '16px', padding: 'clamp(16px, 4vw, 32px)', maxWidth: '90%', width: '600px', margin: '48px auto' }}>
          <h1 className="hero-title" >Take Care Of Your Family</h1>
          <p className="hero-subtitle">
            Money cannot buy more health, time, or energy, but we can help with that. Our mission
is to assist you to recruit the right health care giver for you
          </p>
        <div style={{ display: 'flex', justifyContent: 'center', marginTop: '16px' }}>
          <Link to="/services" onClick={() => window.scrollTo(0, 0)}>
            <button className='button-arrow'>Our Services</button>
          </Link>
        </div>
        </div>
        <div style={{ position: 'absolute', top: 0, left: 0, width: '100%', height: '100%', background: 'rgba(0,0,0,0.25)', zIndex: 1 }}></div>
      </div>

      <div className="App-header-second">
        <div className="hero-text-left">
          <h1 className="hero-title-2">What We Offer</h1>
          <p className="hero-subtitle-2">
            Getting the right care should be simple. We provide features and services that make it easy to manage your health and wellness.
          </p>
        </div>
  <div className="team-cards-container">
          <TeamCard
            name="Booking, Made Simple"
            description="Booking appointments made easy with our user-friendly platform. With just a few clicks, you can schedule your visits at your convenience."
            image={jamesImage}
            target="/bookingform"
            onClick={(e) => {
              e.preventDefault(); // Prevent default link behavior
              window.scrollTo({ top: 0, behavior: 'smooth' }); // Smooth scroll to top
            }}
          />
          <TeamCard
            name="Calendar Tracking"
            description="Keep track of your health appointments and important dates with our integrated calendar feature. Stay organized and never miss a check-up."
            image={jamesImage}
            target="/calendar"
            onClick={(e) => {
              e.preventDefault(); // Prevent default link behavior
              window.scrollTo({ top: 0, behavior: 'smooth' }); // Smooth scroll to top
            }}
          />
          <TeamCard
            name="All Your Health Needs"
            description="Choose from a wide range of services tailored to meet your health and wellness needs. From routine check-ups to specialized care, we've got you covered."
            image={jamesImage}
            target="/services"
            onClick={(e) => {
              e.preventDefault(); // Prevent default link behavior
              window.scrollTo({ top: 0, behavior: 'smooth' }); // Smooth scroll to top
            }}
          />
          <TeamCard
            name="Stay Informed, Stay Connected"
            description="Stay updated with the latest health news and resources. Our platform provides valuable information to help you make informed decisions about your care."
            image={jamesImage}
            target="/connect"
            onClick={(e) => {
              e.preventDefault(); // Prevent default link behavior
              window.scrollTo({ top: 0, behavior: 'smooth' }); // Smooth scroll to top
            }}
          />
        </div>
      </div>
      <div className='Quote-header'>
        <div className="quote-background">
          <div className="slideshow-container">
            <div className="slideshow-images">
              <img src="/caring1.jpg" alt="Caring moment 1" className="slide-image active" style={{ objectPosition: 'center 15%' }} />
              <img src="/caring2.jpg" alt="Caring moment 2" className="slide-image caring2-image" />
              <img src="/caring3.jpg" alt="Caring moment 3" className="slide-image caring3-image" />
              <img src="/caring4.jpg" alt="Caring moment 4" className="slide-image caring4-image" />
              <img src="/caring8.jpg" alt="Caring moment 5" className="slide-image caring5-image" />
              <img src="/caring10.jpg" alt="Caring moment 6" className="slide-image caring6-image" />
            </div>
          </div>
          <div id="subtitle-quote" className='quote-section'>
            At Connection Health Care (CHC), we provide more than care — we provide peace of mind. We treat every loved one with the same dignity and respect as our own family.
          </div>
        </div>
      </div>

      <div className="featured-services">
        <div className="featured-services-container">
          <h2 className="featured-services-title">Featured Services</h2>
          
          {/* Hygiene Care Service */}
          <div className="service-card">
            <div className="service-card-content">
              <h3 className="service-card-title">Daily Living Service</h3>
              <p className="service-card-description">
                At Connection Health Care (CHC). Daily living assistance for seniors provide
compassionate, individualized support with daily personal tasks—such as hygiene,
dressing, meal preparation, and mobility—delivered by our team who prioritize comfort,
dignity, and independence
              </p>
              {/* <ul className="service-list">
                <li className="service-list-item">
                  <span className="service-list-bullet">•</span>
                  Personal bathing and grooming assistance
                </li>
                <li className="service-list-item">
                  <span className="service-list-bullet">•</span>
                  Oral hygiene and dental care support
                </li>
                <li className="service-list-item">
                  <span className="service-list-bullet">•</span>
                  Skin care and pressure sore prevention
                </li>
              </ul> */}
            </div>
            <div className="service-image-container">
              <img 
                src="caring5.jpg" 
                alt="Hygiene Care Services" 
                className="service-image"
                style={{ objectPosition: 'center 5%' }}
              />
            </div>
          </div>

          {/* Health Care Service */}
          <div className="service-card service-card-reversed">
            <div className="service-card-content">
              <h3 className="service-card-title">Personalized Care Service</h3>
              <p className="service-card-description">
                At Connection Health Care (CHC). We provide all the resources needed to create a
personalized care plan that respects your daily routine and adapts to your unique
needs. Together, we’ll design a care plan that supports your well-being and gives your
family peace of mind.
              </p>
              {/* <ul className="service-list">
                <li className="service-list-item">
                  <span className="service-list-bullet">•</span>
                  Vital signs monitoring and health assessments
                </li>
                <li className="service-list-item">
                  <span className="service-list-bullet">•</span>
                  Medication management and administration
                </li>
                <li className="service-list-item">
                  <span className="service-list-bullet">•</span>
                  Chronic condition management and support
                </li>
              </ul> */}
            </div>
            <div className="service-image-container">
              <img 
                src="/live-in.jpg" 
                alt="Live-in Care Services" 
                className="service-image"
              />
            </div>
          </div>
        </div>
      </div>

      <div className="testimonial-section">
        <hr className="testimonial-divider" />
        <p className="testimonial-text">
          We provide all the tools for a personalized care plan that respects your daily routine and is shaped around your needs. Together, we'll design a health care plan that supports you, while giving your children peace of mind.
        </p>
        <hr className="testimonial-divider" style={{ margin: '32px auto 0' }} />
      </div>

      <div className="Why-header steps-section" id="why-we-are">
        <h1 className="hero-title-2 steps-section-title">Finding the Most Professional Care</h1>
        <div className="steps-container">
          <div className="steps-timeline">
            
            {/* Step 1: Book a Consultation */}
            <div className="step-container">
              <div className="step-number">1</div>
              <div className="step-content">
                <h3 className="step-title">Contact Us</h3>
                <p className="step-description">Reach out to us via email or phone number and a member of our team will assist you.</p>
              </div>
            </div>
            
            {/* Step 2: Assessment */}
            <div className="step-container">
              <div className="step-number">2</div>
              <div className="step-content">
                <h3 className="step-title">Add your Information</h3>
                <p className="step-description">Provide details about you or your loved one's needs and preferences to help us tailor our services.</p>
              </div>
            </div>
            
            {/* Step 3: Quotation */}
            <div className="step-container">
              <div className="step-number">3</div>
              <div className="step-content">
                <h3 className="step-title">Select your Services</h3>
                <p className="step-description">Choose from our range of personalized care services to best meet your needs.</p>
              </div>
            </div>
            
            {/* Step 4: Contract */}
            <div className="step-container">
              <div className="step-number">4</div>
              <div className="step-content">
                <h3 className="step-title">Relax and wait</h3>
                <p className="step-description">Our staff and system will handle all the details, keeping you informed every step of the way. Simply wait for the update to appear on your calendar, and accept.</p>
              </div>
            </div>
            
            {/* Step 5: Service */}
            <div className="step-container">
              <div className="step-number">5</div>
              <div className="step-content">
                <h3 className="step-title">Enjoy the Service</h3>
                <p className="step-description">We begin providing personalized care with a professional caregiver or personal service worker attending to your senior loved one at home. A daily care log will be updated and shared with the family.</p>
              </div>
            </div>
          </div>
        </div>
      </div>

  <ContactForm />
  <Footer />
    </div>
  );
}

export default Home;
